import PropTypes from 'prop-types';
import React from 'react';

import { shortMonth } from '../../lib/dateFormatter';

import './index.scss';

// ALO-244 Refactor this component and the one with a similar name in the sections/provisional-offer-options folder

const ChosenSchoolDetailsDisplay = ({
  schoolName,
  universityName,
  courseName,
  periodStartDate,
  periodEndDate,
}) => {
  const formattedStartDate = shortMonth(new Date(periodStartDate));
  const formattedEndDate = shortMonth(new Date(periodEndDate));

  return (
    <div className="chosen-school-and-course-display">
      <div className="chosen-school-and-course-display__details">
        <ul>
          <li className="chosen-school-and-course-display__details__school">
            <div>
              {universityName && (
                <div className="chosen-school-and-course-display__details__school__university h4">
                  {universityName}
                </div>
              )}

              <div
                className={`chosen-school-and-course-display__details__school__${
                  universityName ? 'school' : 'university'
                }`}
              >
                {schoolName}
              </div>
            </div>
          </li>
          <li className="chosen-school-and-course-display__details__course mt-2">{courseName}</li>
          <li className="chosen-school-and-course-display__details__startdate mt-2">
            {formattedStartDate} - {formattedEndDate}
          </li>
        </ul>
      </div>
    </div>
  );
};

ChosenSchoolDetailsDisplay.propTypes = {
  schoolName: PropTypes.string.isRequired,
  universityName: PropTypes.string,
  courseName: PropTypes.string.isRequired,
  periodStartDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  periodEndDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ChosenSchoolDetailsDisplay;
